import React from 'react';
import { ConfigProvider } from 'antd';
const pietraTheme = {
  token: {
    colorPrimary: '#f9e070',
    colorError: '#ff5c3c',
    colorLink: '#141414',
    colorLinkHover: '#141414',
    colorLinkActive: '#141414',
    borderRadius: 6,
    wireframe: false,
    fontFamily: "'Labil Grotesk', sans-serif",
    colorTextPlaceholder: 'rgba(20, 20, 20, 0.6)',
  },
  components: {
    Dropdown: {},
    Message: { colorBgElevated: '#141414', borderRadius: 0, borderRadiusLG: 0, controlHeightLG: 55 },
    Radio: { colorPrimary: '#141414', colorPrimaryHover: '#141414' },
    Checkbox: { colorPrimary: '#141414', colorPrimaryHover: '#141414' },
    Select: { colorPrimaryHover: '#141414', colorPrimary: '#141414' },
    Input: { colorPrimary: '#141414', colorPrimaryHover: '#141414' },
  },
};

const withTheme = (node: JSX.Element) => (
  <ConfigProvider prefixCls="pietra" theme={pietraTheme}>
    {node}
  </ConfigProvider>
);

export default withTheme;
